import { useSwipeable } from 'react-swipeable';
import { Button } from '@ais-ui/ui-core';
import { XIcon } from 'lucide-react';
import { MobileFilterList } from './MobileFilterList';

interface FilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const FilterDrawer = ({ isOpen, onClose }: FilterDrawerProps) => {
  // Swipe right to close (same as vessel details)
  const handlers = useSwipeable({
    onSwipedRight: () => onClose(),
    trackMouse: false,
    preventScrollOnSwipe: false,
    delta: 50,
  });

  if (!isOpen) return null;

  return (
    <div
      {...handlers}
      className="fixed inset-0 z-50 bg-background flex flex-col overflow-hidden"
    >
      {/* Sticky Header - matching vessel details layout */}
      <header className="sticky top-0 z-10 bg-background border-b px-4 py-3 flex items-center justify-between shadow-sm safe-area-inset-x">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="shrink-0"
        >
          <XIcon className="h-6 w-6" />
        </Button>
        <h1 className="text-lg font-semibold truncate flex-1 text-center mx-2">
          Filters
        </h1>
        {/* Spacer for symmetry */}
        <div className="w-10 shrink-0"></div>
      </header>

      {/* Scrollable Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <MobileFilterList onFilterClick={onClose} />
      </div>
    </div>
  );
};
